import React from 'react';
import ReactDOM from 'react-dom/client';
import moment from 'moment';
import 'moment/locale/sv';
import HeaderTeamLogos from './sections/HeaderTeamLogos';
import StandingsTableBody from './sections/Standings';
// import TodaysMatches from './sections/TodaysMatches';
// import Leaders from './Leaders';
import SingleTeam from './sections/SingleTeam';
import Player from './sections/Player';
import Matches from './pages/Matches';
import DataContextProvider from './context/data-context';
import LeadersTableBody from './sections/Leaders';
import SpectatorsTableBody from './sections/Spectators';
import MatchesToday from './sections/MatchesToday';
import CurrentMatches from './sections/CurrentMatches';
import TeamNews from './sections/TeamNews';
import MatchDetails from './pages/MatchDetails';
import HighlightsReelCarousel from './components/FotbollPlay/HighlightsReelCarousel';
import UserControlsComponent from './components/UserControls';
import StatsSeasonSelector from './components/StatsSeasonSelector';
import UserProvider from './context/user-context';
import SpectatorWidget from './components/Spectators/SpectatorWidget';
import LatestHighlights from './components/LatestHighlights';
import TeamTickets from './sections/TeamTickets';
import StatsPage from './sections/StatsPage';
import TeamCalendars from './sections/TeamCalendars';
import LatestCoverage from './components/LatestCoverage';
import TeamLogosCarousel from './sections/TeamLogosCarousel';

moment.locale('sv');

if (document.getElementById('stats-page')) {
  const statsSeasonSelector = ReactDOM.createRoot(
    document.getElementById('stats-page')
  );
  statsSeasonSelector.render(
    <React.StrictMode>
      <DataContextProvider>
        <StatsPage />
      </DataContextProvider>
    </React.StrictMode>
  );
}

if (document.getElementById('r-team-bar')) {
  const header = ReactDOM.createRoot(document.getElementById('r-team-bar'));
  header.render(
    <React.StrictMode>
      <DataContextProvider>
        <HeaderTeamLogos />
      </DataContextProvider>
    </React.StrictMode>
  );
}

if (document.getElementById('team-carousel')) {
  const root = ReactDOM.createRoot(document.getElementById('team-carousel'));
  root.render(
    <React.StrictMode>
      <DataContextProvider>
        <TeamLogosCarousel />
      </DataContextProvider>
    </React.StrictMode>
  );
}

if (document.getElementById('team-tickets')) {
  const header = ReactDOM.createRoot(document.getElementById('team-tickets'));
  header.render(
    <React.StrictMode>
      <DataContextProvider>
        <TeamTickets />
      </DataContextProvider>
    </React.StrictMode>
  );
}

if (document.getElementById('team-calendar')) {
  const header = ReactDOM.createRoot(document.getElementById('team-calendar'));
  header.render(
    <React.StrictMode>
      <DataContextProvider>
        <UserProvider>
          <TeamCalendars />
        </UserProvider>
      </DataContextProvider>
    </React.StrictMode>
  );
}

if (document.getElementById('single-team')) {
  const singleTeam = ReactDOM.createRoot(
    document.getElementById('single-team')
  );
  singleTeam.render(
    <React.StrictMode>
      <DataContextProvider>
        <SingleTeam />
      </DataContextProvider>
    </React.StrictMode>
  );
}

if (document.getElementById('player')) {
  const player = ReactDOM.createRoot(document.getElementById('player'));
  player.render(
    <React.StrictMode>
      <DataContextProvider>
        <Player />
      </DataContextProvider>
    </React.StrictMode>
  );
}

if (document.getElementById('matches-page')) {
  const matches = ReactDOM.createRoot(document.getElementById('matches-page'));
  matches.render(
    <React.StrictMode>
      <DataContextProvider>
        <Matches />
      </DataContextProvider>
    </React.StrictMode>
  );
}

if (document.getElementById('standings-table-body')) {
  const standingsTableBody = ReactDOM.createRoot(
    document.getElementById('standings-table-body')
  );
  standingsTableBody.render(
    <React.StrictMode>
      <DataContextProvider>
        <StandingsTableBody />
      </DataContextProvider>
    </React.StrictMode>
  );
}

if (document.getElementById('leaders-goal-table-body')) {
  const leadersGoalTable = ReactDOM.createRoot(
    document.getElementById('leaders-goal-table-body')
  );
  leadersGoalTable.render(
    <React.StrictMode>
      <DataContextProvider>
        <LeadersTableBody type="goals" />
      </DataContextProvider>
    </React.StrictMode>
  );
}

if (document.getElementById('leaders-assist-table-body')) {
  const leadersAssistTable = ReactDOM.createRoot(
    document.getElementById('leaders-assist-table-body')
  );
  leadersAssistTable.render(
    <React.StrictMode>
      <DataContextProvider>
        <LeadersTableBody type="assists" />
      </DataContextProvider>
    </React.StrictMode>
  );
}

if (document.getElementById('leaders-assist-table-body-limit-5')) {
  const leadersAssistTable = ReactDOM.createRoot(
    document.getElementById('leaders-assist-table-body-limit-5')
  );
  leadersAssistTable.render(
    <React.StrictMode>
      <DataContextProvider>
        <LeadersTableBody type="assists" limit={5} />
      </DataContextProvider>
    </React.StrictMode>
  );
}

if (document.getElementById('leaders-goals-table-body-limit-5')) {
  const leadersGoalsTable = ReactDOM.createRoot(
    document.getElementById('leaders-goals-table-body-limit-5')
  );
  leadersGoalsTable.render(
    <React.StrictMode>
      <DataContextProvider>
        <LeadersTableBody type="goals" limit={5} />
      </DataContextProvider>
    </React.StrictMode>
  );
}

if (document.getElementById('spectators-table-body')) {
  const spectatorsTable = ReactDOM.createRoot(
    document.getElementById('spectators-table-body')
  );
  spectatorsTable.render(
    <React.StrictMode>
      <DataContextProvider>
        <SpectatorsTableBody />
      </DataContextProvider>
    </React.StrictMode>
  );
}

if (document.getElementById('fotbollplay-latest-coverage')) {
  const latestCoverage = ReactDOM.createRoot(
    document.getElementById('fotbollplay-latest-coverage')
  );
  latestCoverage.render(
    <React.StrictMode>
      <DataContextProvider>
        <UserProvider>
          <LatestCoverage />
        </UserProvider>
      </DataContextProvider>
    </React.StrictMode>
  );
}

if (document.getElementById('matches-today')) {
  const matchesTodaySection = ReactDOM.createRoot(
    document.getElementById('matches-today')
  );
  matchesTodaySection.render(
    <React.StrictMode>
      <DataContextProvider>
        <MatchesToday />
      </DataContextProvider>
    </React.StrictMode>
  );
}

if (document.getElementById('current-matches')) {
  const CurrentMatchesSection = ReactDOM.createRoot(
    document.getElementById('current-matches')
  );
  CurrentMatchesSection.render(
    <React.StrictMode>
      <DataContextProvider>
        <CurrentMatches />
      </DataContextProvider>
    </React.StrictMode>
  );
}

if (document.getElementById('current-matches-on-match-day')) {
  const CurrentMatchesSection = ReactDOM.createRoot(
    document.getElementById('current-matches-on-match-day')
  );
  CurrentMatchesSection.render(
    <React.StrictMode>
      <DataContextProvider>
        <CurrentMatches showOnMatchDay />
      </DataContextProvider>
    </React.StrictMode>
  );
}

if (document.getElementById('matchdetails')) {
  const Match = ReactDOM.createRoot(document.getElementById('matchdetails'));
  Match.render(
    <React.StrictMode>
      <DataContextProvider>
        <UserProvider>
          <MatchDetails />
        </UserProvider>
      </DataContextProvider>
    </React.StrictMode>
  );
}

if (document.getElementById('team-news')) {
  const tNews = ReactDOM.createRoot(document.getElementById('team-news'));
  tNews.render(
    <React.StrictMode>
      <DataContextProvider>
        <TeamNews postAmount={4} />
      </DataContextProvider>
    </React.StrictMode>
  );
}

if (document.getElementById('team-news-page')) {
  const tNewsPage = ReactDOM.createRoot(
    document.getElementById('team-news-page')
  );
  tNewsPage.render(
    <React.StrictMode>
      <DataContextProvider>
        <TeamNews postAmount={40} />
      </DataContextProvider>
    </React.StrictMode>
  );
}

if (document.getElementById('highlights-carousel')) {
  const carousel = ReactDOM.createRoot(
    document.getElementById('highlights-carousel')
  );
  carousel.render(
    <React.StrictMode>
      <DataContextProvider>
        <UserProvider>
          <HighlightsReelCarousel />
        </UserProvider>
      </DataContextProvider>
    </React.StrictMode>
  );
}

if (document.getElementById('user-controls-desktop')) {
  const userControlsDesktop = ReactDOM.createRoot(
    document.getElementById('user-controls-desktop')
  );
  userControlsDesktop.render(
    <React.StrictMode>
      <DataContextProvider>
        <UserProvider>
          <UserControlsComponent type="desktop" />
        </UserProvider>
      </DataContextProvider>
    </React.StrictMode>
  );
}

if (document.getElementById('user-controls-mobile')) {
  const userControlsMobile = ReactDOM.createRoot(
    document.getElementById('user-controls-mobile')
  );
  userControlsMobile.render(
    <React.StrictMode>
      <DataContextProvider>
        <UserProvider>
          <UserControlsComponent type="mobile" />
        </UserProvider>
      </DataContextProvider>
    </React.StrictMode>
  );
}

if (document.getElementById('stats-season-selector')) {
  const statsSeasonSelector = ReactDOM.createRoot(
    document.getElementById('stats-season-selector')
  );
  statsSeasonSelector.render(
    <React.StrictMode>
      <DataContextProvider>
        <StatsSeasonSelector />
      </DataContextProvider>
    </React.StrictMode>
  );
}

if (document.getElementById('spectator-widget')) {
  const statsSeasonSelector = ReactDOM.createRoot(
    document.getElementById('spectator-widget')
  );
  statsSeasonSelector.render(
    <React.StrictMode>
      <DataContextProvider>
        <SpectatorWidget />
      </DataContextProvider>
    </React.StrictMode>
  );
}

if (document.getElementById('latest-highlights')) {
  const statsSeasonSelector = ReactDOM.createRoot(
    document.getElementById('latest-highlights')
  );
  statsSeasonSelector.render(
    <React.StrictMode>
      <DataContextProvider>
        <UserProvider>
          <LatestHighlights />
        </UserProvider>
      </DataContextProvider>
    </React.StrictMode>
  );
}
